import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api/selectitem';
import { OptionLicense } from '../../models/option-licence.model';
import { TenantLicense } from '../../models/tenant-license.model';
import { UserLicense } from '../../models/user-licence.model';
import { TenantLicenseService } from '../../services/tenant-license.service';
import { UserLicenceService } from '../../services/user-licence.service';
@Component({
  selector: 'iw-new-tenant',
  templateUrl: './iw-new-tenant.component.html',
})
export class IwNewTenantComponent {
  @Input()
  public display: boolean;
  @Input()
  public displayUpdate?: boolean;
  @Input()
  public displayUpdateOptions?: boolean;

  public tenantLicense: TenantLicense = new TenantLicense();

  @Input()
  public set tenantOptions(tenant: TenantLicense) {
    this.tenantLicense = tenant;
    this.initializeTenant(tenant);
  }

  @Input()
  public expirationDate: Date = new Date();
  @Input()
  public popUpName?: string;
  @Input()
  public status?: SelectItem[];
  @Input()
  public optionsList?: OptionLicense[];
  @Output()
  public changeDisplay: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public updateTenant:
    EventEmitter<TenantLicense[]> = new EventEmitter<TenantLicense[]>();
  @Output()
  public updateTenantOptions:
    EventEmitter<OptionLicense[]> = new EventEmitter<OptionLicense[]>();
  public warningMessage?: string;

  public get tenantNameFormName(): any {
    return this.form.controls['tenantName'];
  }

  public get tenantIdFormName(): any {
    return this.form.controls['tenantId'];
  }

  public form: FormGroup;
  private tenantName: FormControl = new FormControl('', Validators.required);
  private tenantId: FormControl = new FormControl('', Validators.required);

  constructor(
    public readonly tenantLicenseService: TenantLicenseService,
    public readonly userLicenseService: UserLicenceService,
    private messageService: MessageService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
  ) {
    this.form = this.formBuilder.group({
      tenantId: this.tenantId,
      tenantName: this.tenantName,
    });
    this.display = true;
  }

  public initializeTenant(tenantLicense: TenantLicense) {
    this.form = this.formBuilder.group({
      tenantId: tenantLicense.tenant,
      tenantName: tenantLicense.tenantName,
    });
  }

  public save(): void {
    if (this.displayUpdate) {
      this.saveUpdateTenant(this.tenantLicense);
    } else {
      this.saveTenant(this.tenantLicense);
    }
  }

  public cancel(): void {
    this.form.reset();
    this.updateTenant.emit(this.tenantLicenseService.getTenant());
    this.onBeforeDialogHide();
  }

  public onBeforeDialogHide(event?: Event): void {
    this.changeDisplay.emit(false);
    this.display = false;
  }

  public changeStatus(date: Date): void {
    this.tenantLicense.status = moment(date)
      .add(1, 'day')
      .isBefore(moment.now())
      ? 'EXPIRED'
      : 'ACTIVE';
  }

  public setTenantId(tenant?: string) {
    if (tenant) {
      this.tenantLicense.tenant = tenant;
    }
  }

  public confirmButtonDisabled() {
    return this.tenantNameFormName.errors?.required ||
      this.tenantIdFormName.errors?.required;
  }

  public setTenantName(tenantName?: string) {
    if (tenantName) {
      this.tenantLicense.tenantName = tenantName;
    }
  }

  private saveTenant(tenant: TenantLicense): void {
    tenant.expirationDate = moment(this.expirationDate);
    this.tenantLicenseService.saveTenant(tenant).subscribe(
      (res) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('Success Message'),
            detail: this.translate.instant('Client Created'),
          });
        }, 1000);
        this.updateTenant.emit(this.tenantLicenseService.getTenant());
      },
      (err) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('Error Message'),
            detail: this.translate.instant('Errors occurred - Client Creation'),
          });
        }, 1000);
      },
    );
    this.onBeforeDialogHide();
  }

  private saveUpdateTenant(tenant: TenantLicense): void {
    tenant.expirationDate = moment(this.expirationDate);
    tenant.optionList = undefined;
    tenant.optionListNames = undefined;
    tenant.registeredLicenseUsers = undefined;
    this.tenantLicenseService.updateTenant(tenant).subscribe(
      (res) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('Success Message'),
            detail: this.translate.instant('Client Updated'),
          });
        }, 1000);
        this.updateTenantOptions.emit(this.optionsList);
      },
      (err) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('Error Message'),
            detail: this.translate.instant('Errors occurred - Update Client'),
          });
        }, 1000);
      },
    );
    this.onBeforeDialogHide();
  }
}
